<template>
    <div class="filter-form">
        <header class="filter-form-header">
            <span>Filter {{property.filterFormLabel || property.label}}</span>
        </header>
        <div class="filter-form-body">
            <div class="mb-2 input-container">
                <input ref="textField" @keydown.enter="submit" @input="checkCanClearText">
                <i class="clear-button gf gf-close" v-if="canClearText" @click="clearValue"></i>
            </div>
            <button class="button-primary" @click="submit">Apply</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "TextMessage",
        methods: {
            clearValue() {
                this.fillValue(null);
                this.focus();
            },
            focus() {
                this.$refs.textField.focus();
            },
            getValue() {
                const text = this.$refs.textField.value.trim();
                if (text) {
                    return {
                        value: text
                    }
                }
                return null;
            },
            fillValue(payload) {
                const textField = this.$refs.textField;
                if (payload) {
                    textField.value = payload.value;
                } else {
                    textField.value = '';
                }
                this.checkCanClearText();
            },
            submit() {
                this.$emit('doSubmit', this.property.propertyKey, this.getValue());
                this.doClose();
            },
            doClose() {
                this.$emit('doClose', this.property.propertyKey);
            },
            checkCanClearText() {
                this.canClearText = !!this.getValue();
            }
        },
        props: {
            property: Object,
        },
        data() {
            return {
                canClearText: false,
            }
        }
    }
</script>

<style scoped lang="scss">
    .input-container {
        position: relative;

        input {
            padding-right: 1rem;
        }

        &:hover {
            .clear-button {
                opacity: 0.5;
            }
        }

        .clear-button:hover {
            opacity: 1;
        }
    }

    .clear-button {
        position: absolute;
        top: 0;
        right: 3px;
        line-height: 22px;
        font-size: 0.86em;
        opacity: 0;
    }
</style>
